<template>
    <div class="panel">
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="100"
                    prop="typeName"
                    label="名称" >
                </el-table-column>
                <el-table-column
                    label="是否开启" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enable"
                                   @change="sub(scope.row)"
                                   inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column>

            </el-table>
        </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        props: [
             "attr"
        ],
        data() {
            return {
                form: {
                    ...this.attr,
                },
                tableData: [
                    {
                        type: 1,
                        typeName: '姓名',
                        enable: false,
                    },
                    {
                        type: 2,
                        typeName: '性别',
                        enable: false,
                    },
                    {
                        type: 3,
                        typeName: '年龄',
                        enable: false,
                    },
                    {
                        type: 8,
                        typeName: '电话',
                        enable: false,
                    },
                    {
                        type: 4,
                        typeName: '学校',
                        enable: false,
                    },
                    {
                        type: 5,
                        typeName: '年级',
                        enable: false,
                    },
                    {
                        type: 6,
                        typeName: '班级',
                        enable: false,
                    },
                    {
                        type: 7,
                        typeName: '备注',
                        enable: false,
                    },
                ],
            }
        },
        watch: {

        },
        methods: {
            loadData() {//如果有数据就替换 没有就用上面定义的
                this.$ajaxPost("/activityBuiltInForm/list",{form:this.form}, (data) => {
                    if(data.result.length > 0){
                         this.tableData.forEach((item,i) => {
                            if (data.result.some(res => res.type == item.type)) {
                                let result = data.result.filter(res1 =>  res1.type == item.type)[0];
                                this.tableData[i].id = result.id;
                                this.tableData[i].enable = result.enable;
                            }
                        })
                    }
                })
            },
            sub(item) {
                let data = this.tableData;
                item.activityId = this.attr.activityId;
                this.$ajaxPost("/activityBuiltInForm/save", {
                    activity: item
                }, (data) => {
                    this.$showSuccess("保存成功");
                    this.loadData();
                })
                return false;
            },
        },
        created() {
            this.loadData();
        }

    }
</script>
